import React, { useState } from 'react';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';
import WorkExperience from './WorkExperience';

const About = () => {
  const [showWorkExperience, setShowWorkExperience] = useState(false);

  return (
    <section
      id="about"
      className="w-full bg-gradient-to-b from-gray-950 to-black text-white py-24"
    >
      <div className="max-w-screen-lg mx-auto px-6">
        <div className="mb-8">
          <p className="text-sm uppercase tracking-[0.25em] text-cyan-400 font-semibold mb-2">
            About me
          </p>
          <h2 className="text-4xl sm:text-5xl font-bold">
            Engineering with fundamentals first.
          </h2>
        </div>

        <p className="text-lg sm:text-xl text-gray-300 leading-relaxed max-w-4xl">
          I’m a software engineer focused on backend and cloud-native systems.
          My work spans Java and Spring Boot microservices, event-driven
          architecture, distributed systems, AWS, Kubernetes, CI/CD, data
          platforms, and React/TypeScript applications. I enjoy turning complex
          business requirements into reliable, maintainable software with clear
          tradeoffs, observability, and measurable impact.
        </p>

        <div className="grid md:grid-cols-3 gap-5 mt-10">
          {[
            ['Backend', 'Java • Spring Boot • REST • Security • Kafka'],
            ['Cloud & DevOps', 'AWS • Kubernetes • Docker • Terraform • CI/CD'],
            ['Frontend', 'React • TypeScript • JavaScript • Component Design'],
          ].map(([title, text]) => (
            <div
              key={title}
              className="rounded-2xl border border-white/10 bg-white/[0.04] p-6 transition hover:-translate-y-1 hover:border-cyan-400/40"
            >
              <h3 className="text-xl font-semibold text-white">{title}</h3>
              <p className="mt-3 text-gray-400 leading-relaxed">{text}</p>
            </div>
          ))}
        </div>

        <button
          onClick={() => setShowWorkExperience((value) => !value)}
          className="mt-10 inline-flex items-center gap-2 text-cyan-300 font-semibold hover:text-cyan-200 transition"
          aria-expanded={showWorkExperience}
        >
          {showWorkExperience ? 'Hide Work Experience' : 'View Work Experience'}
          {showWorkExperience ? <FiChevronUp /> : <FiChevronDown />}
        </button>

        {showWorkExperience && <WorkExperience />}
      </div>
    </section>
  );
};

export default About;
